import Icon from "@lib/common/components/Icon/Icon";
import { ActionIcon, Group, Paper, Text, ThemeIcon } from "@mantine/core";

export default function ChatAttachmentChips({
  fileNames,
  onRemove
}: {
  fileNames: string[];
  onRemove?: (index: number) => void;
}) {
  if (fileNames.length === 0) {
    return null;
  }
  return (
    <Group gap="xs" wrap="wrap" mt={5}>
      {fileNames.map((fileName, index) => (
        <Paper
          key={`${fileName}-${index}`}
          variant="light"
          color="gray"
          px="xs"
          pr={5}
          pl={5}
          pt={5}
          py={5}
          bg="var(--mantine-color-gray-outline-hover)"
          radius="md"
        >
          <Group justify="space-between" gap="lg">
            <Group gap="xs">
              <ThemeIcon color="red" radius="md">
                <Icon name="paperclip" size="0.8rem" variant="solid" />
              </ThemeIcon>
              <Text size="sm" fw={500}>
                {fileName}
              </Text>
            </Group>

            {typeof onRemove === "function" && (
              <ActionIcon size="md" variant="subtle" color="gray" onClick={() => onRemove(index)}>
                <Icon name="xmark" size="0.8rem" variant="solid" />
              </ActionIcon>
            )}
          </Group>
        </Paper>
      ))}
    </Group>
  );
}
